import ajax from '../ajax'

// /api/report/index
export function ERPIndexApi(data) {
    return ajax({
        method:'post',
        url: 'api/report/index',
        data
    })
}


/// api/report/search
export function ERPSearchApi(data) {
    return ajax({
        method:'post',
        url: 'api/report/search',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/report/index.js